


























































































































































































































































































































































import Vue from 'vue';
import { format } from 'date-fns';
import { eValidationRules, isFormValid } from '@/validation.ts';
import * as Util from '@/util.ts';
import * as Enums from '@/enums.ts';
import * as Constants from '@/constants.ts';
import firebase from 'firebase/app';

export default Vue.extend({
  data() {
    return {
      currSelectedOrderItem: {} as OrderItem,
      currSelectedOrderItemType: '',
      showAdditionalOptionsModal: false,
      eNotificationStatuses: Enums.eNotificationStatuses,
      eOrderStatuses: Enums.eOrderStatuses,
      paymentIntentCreated: false,
    };
  },
  mounted() {
    this.onPageLoad();
  },
  computed: {
    currentClientUser() {
      return this.$store.state.currentClientUser;
    },
    isKioskMode(): boolean {
      return this.$store.state.isKioskMode;
    },
    isDeliveryMode(): boolean {
      return this.$store.state.appMode === Enums.eAppModes.delivery;
    },
    isTakeoutMode(): boolean {
      return this.$store.state.appMode === Enums.eAppModes.takeout;
    },
    isTablesideMode(): boolean {
      return this.$store.state.appMode === Enums.eAppModes.tableside;
    },
    appMode(): boolean {
      return this.$store.state.appMode;
    },
    readyToPay(): boolean {
      return Boolean(this.tablesideAcceptedOrders.length && !this.tablesidePendingOrders.length);
    },
    lastSentOrders(): OrderItem[] {
      return this.$store.state.lastSentOrders;
    },
    toBeSentOrders(): OrderItem[] {
      return this.$store.state.toBeSentOrders;
    },
    tablesidePendingOrders(): OrderItem[] {
      return this.$store.getters.tablesidePendingOrders;
    },
    tablesideAcceptedOrders(): OrderItem[] {
      return this.$store.getters.tablesideAcceptedOrders;
    },
    tablesideRejectedOrders(): OrderItem[] {
      return this.$store.getters.tablesideRejectedOrders;
    },
    tablesideCancelledOrders(): OrderItem[] {
      return this.$store.getters.tablesideCancelledOrders;
    },
    pendingDeliveryOrders(): DeliveryOrderObject[] {
      return this.$store.getters.pendingDeliveryOrders;
    },
    pendingTakeoutOrders(): TakeoutOrderObject[] {
      return this.$store.getters.pendingTakeoutOrders;
    },
    acceptedDeliveryOrders(): DeliveryOrderObject[] {
      return this.$store.getters.acceptedDeliveryOrders;
    },
    acceptedTakeoutOrders(): TakeoutOrderObject[] {
      return this.$store.getters.acceptedTakeoutOrders;
    },
    dispatchedDeliveryOrders(): DeliveryOrderObject[] {
      return this.$store.getters.dispatchedDeliveryOrders;
    },
    readyForPickUpTakeoutOrders(): TakeoutOrderObject[] {
      return this.$store.getters.readyForPickUpTakeoutOrders;
    },
    rejectedDeliveryOrders(): DeliveryOrderObject[] {
      return this.$store.getters.rejectedDeliveryOrders;
    },
    rejectedTakeoutOrders(): TakeoutOrderObject[] {
      return this.$store.getters.rejectedTakeoutOrders;
    },
    atLeastOneThingWasOrdered(): boolean {
      return Boolean(this.$store.state.lastSentOrders.length);
    },
    initializationComplete(): boolean {
      return this.$store.state.initializationComplete;
    },
  },
  watch: {
    initializationComplete() {
      this.showSignInFunc();
    },
    appMode() {
      this.onPageLoad();
    },
    $route(to, from) {
      if (to.fullPath.includes(Constants.allRoutes.order)) {
        this.onPageLoad();
      }
    },
  },
  methods: {
    getOrderItemMinimumQuantity(orderItem: OrderItem) {
      const menuItem: MenuItem = Util.masterResourceDictionary[orderItem.menuItemDocId] as MenuItem;
      return menuItem.minimumQuantity || 1;
    },
    onPageLoad() {
      switch (this.$store.state.appMode) {
        case Enums.eAppModes.tableside:
          if (Util.localStoreGetSimple('tutorialStep') === '2') {
            Util.doTutorialStep(2);
          }
          break;
        case Enums.eAppModes.takeout:
        case Enums.eAppModes.delivery:
          // So that navigation happens first.
          this.showSignInFunc();
          break;
      }
    },
    showSignInFunc() {
      if (!this.$store.state.currentClientUser && this.$store.state.initializationComplete && this.$store.state.appMode !== Enums.eAppModes.tableside) {
        Vue.nextTick(() => {
          Util.rootComponent.showSignInFunc(Util.t?.accountRequired, false);
        });
      }
    },
    reorderOrderItem() {
      const newToBeSentOrders = [
        ...this.toBeSentOrders,
        {
          ...this.$data.currSelectedOrderItem,
          orderItemId: Util.generateId(),
        },
      ];
      Util.setToBeSentOrders(newToBeSentOrders);
      this.closeAdditionalOptionsModal();
    },
    removeSingleOrderItem() {
      const newToBeSentOrders = this.toBeSentOrders.map((oi: OrderItem) => {
        if (oi.orderItemId === this.$data.currSelectedOrderItem.orderItemId) {
          const newQuantity = oi.quantity - 1;
          const newTotalPrice = oi.totalPrice - oi.priceWithModifiers;
          return {
            ...oi,
            totalPrice: newTotalPrice,
            totalPriceWithTax: Math.round(newTotalPrice * Util.getTaxRateFor(this.$store.state.menuItemArray.find((menuItem: MenuItem) => menuItem.docId === oi.menuItemDocId))),
            quantity: newQuantity,
          } as OrderItem;
        }
        return oi;
      });
      Util.setToBeSentOrders(newToBeSentOrders);
      this.closeAdditionalOptionsModal();
    },
    removeOrderItem() {
      const newToBeSentOrders = this.toBeSentOrders.filter((oi: OrderItem) => oi.orderItemId !== this.$data.currSelectedOrderItem.orderItemId);
      Util.setToBeSentOrders(newToBeSentOrders);
      this.closeAdditionalOptionsModal();
    },
    cancelPendingOrderItem() {
      const oldUserEstablishmentExchangeObject: UserEstablishmentExchangeObject = this.$store.state.currentUserEstablishmentExchangeObject;
      const currOrderItem = this.$data.currSelectedOrderItem;

      // If the pending item still exists in the pending orders array and wasn't removed by another party while we had the modal open.
      if (!this.tablesidePendingOrders.some((oi: OrderItem) => oi.orderItemId === currOrderItem.orderItemId)) {
        Util.showError(Util.t?.thatItemHasBeenRemovedFromTablesidePendingOrders);
        return;
      }

      const newNotificationsToTheEstablishment =
        oldUserEstablishmentExchangeObject.notificationsToTheEstablishment.map((n) => {
          if (n.notificationId === currOrderItem.notificationId) {
            const notificationCopy: OrderNotification = { ...(n as OrderNotification) };
            notificationCopy.orderItems = (notificationCopy.orderItems as OrderItem[]).filter((oi) => {
              return oi.orderItemId !== currOrderItem.orderItemId;
            });
            return notificationCopy;
          }
          return n;
        }) || [];

      const newOrderItemsForOrder = oldUserEstablishmentExchangeObject.tablesideOrderCollection[currOrderItem.orderInstanceId].orderItems.filter((oi) => {
        return oi.orderItemId !== currOrderItem.orderItemId;
      });

      const update: any = {
        notificationsToTheEstablishment: newNotificationsToTheEstablishment,
      };

      if (newOrderItemsForOrder.length) {
        update[`tablesideOrderCollection.${currOrderItem.orderInstanceId}.orderItems`] = newOrderItemsForOrder;
      } else {
        update[`tablesideOrderCollection.${currOrderItem.orderInstanceId}.orderItems`] = firebase.firestore.FieldValue.delete();
      }

      Util.updateExchangeObject(update, Util.t?.orderItemWasSuccessfullyCancelled);
      this.closeAdditionalOptionsModal();
    },
    cancelAcceptedOrderItem() {
      // If the pending item still exists in the pending orders array and wasn't removed by another party while we had the modal open.
      if (!this.tablesideAcceptedOrders.some((oi: OrderItem) => oi.orderItemId === this.$data.currSelectedOrderItem.orderItemId)) {
        Util.showError(Util.t?.thatItemHasBeenRemovedFromTablesideAcceptedOrders);
        return;
      }

      const notification: CancellationRequestNotification = {
        notificationId: Util.generateId(),
        status: Enums.eNotificationStatuses.pending,
        type: Enums.eNotificationTypes.cancellationRequest,
        cancellationRequestOrderItemId: this.$data.currSelectedOrderItem.orderItemId,
        orderItems: [this.$data.currSelectedOrderItem],
      };

      Util.sendNotificationToEstablishment(notification);
      this.closeAdditionalOptionsModal();
    },
    setLastPendingOrder() {
      Util.setToBeSentOrders(
        this.lastSentOrders.map((oi: OrderItem) => {
          return {
            ...oi,
            orderItemId: Util.generateId(), // Generate new ids for the copy.
          };
        })
      );
    },
    // clearOrder() {
    //   Util.setToBeSentOrders([]);
    // },
    closeAdditionalOptionsModal() {
      this.$data.showAdditionalOptionsModal = false;
      this.$data.currSelectedOrderItemType = '';
    },
    onOrderItemClick(orderItem: OrderItem, type: string) {
      this.$data.currSelectedOrderItem = orderItem;
      this.$data.currSelectedOrderItemType = type;
      this.$data.showAdditionalOptionsModal = true;
    },
    signOut() {
      Util.signOut();
    },
    onReadyToPay() {
      Util.routerPush({ path: Constants.allRoutes.pay });
    },
    getExpectedWaitString(GenericOrderObject: GenericOrderObject): string {
      const matchingNotification: AnyNotification = this.$store.state.currentUserEstablishmentExchangeObject.notificationsToTheUser.find((notification: AnyNotification) => {
        return notification.orderInstanceId === GenericOrderObject.orderInstanceId;
      });
      if (matchingNotification && matchingNotification.expectedWait) {
        return Util.t?.shouldBeReadyBy.supplant([format(new Date(GenericOrderObject.dateCreated + matchingNotification.expectedWait * 60 * 1000), 'h:mma')]);
      }
      return '';
    },
  },
});
